import createCheckoutSession from 'api/v1/subscriptions/createCheckoutSession';
import { stripe as stripeConfig } from 'config';
import useMutation from 'hooks/react-query/useMutation';
import type { IUser } from 'types/users.types';
import { SentryIgnoredError } from 'utils/SentryIgnoredError';

const useRedirectToCheckoutSession = (user: IUser | undefined) => {
  return useMutation(createCheckoutSession, {
    onSuccess: ({ id }) => {
      if (!user || !window.Stripe)
        throw new SentryIgnoredError('Data not loaded');
      const country = user.country;
      const stripe = window.Stripe(stripeConfig.key[country]);
      stripe.redirectToCheckout({
        sessionId: id,
      });

      return new Promise(() => {});
    },
  });
};

export default useRedirectToCheckoutSession;
